export default "__VITE_ASSET__DLki84Ja__"